'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// ../node_modules/react-dom/index.js
// module id = 259
// module chunks = 0